// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async getPort({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/ports/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    async getPorts({ commit, state, rootState, rootGetters }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/ports`, config);
            commit('updatePortList', response.data)
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
    async getPortsByController({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/ports/by-controller/${id}`, config);
            commit('updatePortList', response.data)
            return response.data;
        } catch (error) {
            return error;
        }
    },

    async getPortsByControllersIds({ commit, state, rootState, rootGetters }, payload) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        let data ={
            "controller_ids" : payload
        }

        try {
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/ports/by-controller-ids`, data, config);
            commit('updatePortList', response.data)
            return response.data;
        } catch (error) {
            return error;
        }
    },

    async updatePort({ commit, state, rootState, rootGetters }, payload) {
        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/ports/${payload.id}`,
                {
                    name: payload.name,
                    rhg_port: payload.rhg_port,
                    controller_id: payload.controller_id
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Update failed'
                };
            } else if (error.request) {
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

};
